import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { TOrderPayload } from 'types/order/vendorDashboard/TOrderPayload';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { vendorDocumentsInitialState } from './interfaces';

export const vendorDocumentsReducer = createSlice({
  name: 'vendorDocuments',
  initialState: vendorDocumentsInitialState,
  reducers: {
    setVendorDocumentsDataAction: (state, action: PayloadAction<TOrderPayload<IStandardDocumentVersionData[]>>) => {
      state.documents[action.payload.orderId] = action.payload.value;
    },
    setVendorDocumentsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.documentsFetchStatus = action.payload;
    },
    setVendorDocumentsErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.documentsError = action.payload;
    },
    setUploadVendorDocumentFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.uploadDocumentsFetchStatus = action.payload;
    },
    setUploadVendorDocumentErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.uploadDocumentsError = action.payload;
    },
    setDeleteVendorDocumentFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.deleteDocumentsFetchStatus = action.payload;
    },
    setDeleteVendorDocumentErrorAction: (state, action: PayloadAction<string | undefined>) => {
      state.deleteDocumentsError = action.payload;
    },
  },
});
export const {
  setVendorDocumentsDataAction,
  setVendorDocumentsFetchStatusAction,
  setVendorDocumentsErrorAction,
  setUploadVendorDocumentErrorAction,
  setUploadVendorDocumentFetchStatusAction,
  setDeleteVendorDocumentErrorAction,
  setDeleteVendorDocumentFetchStatusAction,
} = vendorDocumentsReducer.actions;
